import * as defaultEnvConstants from './post-office-environment/constants';
export { usePostOfficeContext, PostOfficeContext, PostOfficeContextProvider } from './post-office-context';
export { PostOfficeEnvironmentProvider, usePostOfficeEnvironment } from './post-office-environment';
var REMOTE_MODULE_URI_LOCAL = defaultEnvConstants.REMOTE_MODULE_URI_LOCAL,
  REMOTE_MODULE_URI_PROD = defaultEnvConstants.REMOTE_MODULE_URI_PROD,
  REMOTE_MODULE_URI_STG = defaultEnvConstants.REMOTE_MODULE_URI_STG,
  API_ORIGIN_LOCAL = defaultEnvConstants.API_ORIGIN_LOCAL,
  API_PATHNAME_LOCAL = defaultEnvConstants.API_PATHNAME_LOCAL,
  API_PATHNAME_STG_PROD = defaultEnvConstants.API_PATHNAME_STG_PROD;
export { REMOTE_MODULE_URI_LOCAL, REMOTE_MODULE_URI_PROD, REMOTE_MODULE_URI_STG, API_ORIGIN_LOCAL, API_PATHNAME_LOCAL, API_PATHNAME_STG_PROD };
export { useStableObject } from './util/use-stable-object';
export { usePostOfficeContextScope as useContextScope } from './post-office-context-scope';
export { useMessagePlacementHooks } from './post-office/message-placement';
export { PostOfficeProvider } from './post-office';
export { usePostOfficeRouteUpdate } from './post-office-route/listener';
export { PostOfficeRouteContext, usePostOfficeRoute } from './post-office-route/exports';